import React from 'react'
import { useCurrentLocale } from '../../src/contexts/CurrentLanguageContext'
import { usePossibleLocales } from '../../src/hooks/usePossibleLocales'
import { VendorFragment } from '../../src/model/fragments'
import { getLocale } from '../../src/model/locale'
import { getPlaceLink } from '../../src/model/urls'
import { CardView } from '../Card'
import { CardBox, CardBoxProps } from '../CardBox'
import { PhoneNumbers } from '../PhoneNumbers'

export interface VendorCardProps extends Pick<CardBoxProps, 'onDismiss' | 'onClick'> {
	place: VendorFragment
}

export const VendorCard: React.FC<VendorCardProps> = ({
	place,
	onDismiss,
	onClick
}) => {
	const locale = useCurrentLocale();
	const possibleLocales = usePossibleLocales();
	const data = getLocale(place.locales, possibleLocales);

	if(!data)
	{
		return <></>;
	}

	return (
		<CardBox
			title={data.title}
			FlexiLinkProps={
				place.link
					? {
							nextLink: getPlaceLink(
								locale,
								place.id,
								place.link.url,
							),
					  }
					: undefined
			}
			content={
				<>
					<div>{place.address}</div>
					<div>
						{place.zip} {place.city}
					</div>
					{place.email && (
						<div>
							<a href={`mailto:${place.email}`}>{place.email}</a>
						</div>
					)}
					{place.phone && (
						<div>
							tel.: <PhoneNumbers numbers={place.phone} />
						</div>
					)}
				</>
			}
			view={CardView.small}
			onDismiss={onDismiss}
			onClick={onClick}
		/>
	)
}
